import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#32292F",
        primary1: "#1282a2",
        primary2: "#C7EFCF",
        primary3: "#FF5252",
        secondary: "#5DA271",
        accent: "#C84630",
        error: "#e53935",
        info: "#ffab40",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
});
